import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ToastMessage = () => {
  return (
    <div>
      <ToastContainer
        position="bottom-right"
        progressClassName="Toastify__progress-bar--rtl"
      />
    </div>
  );
};

export default ToastMessage;
